import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoService } from '@ngneat/transloco';
import { cloneDeep } from 'lodash-es';
import { QuarantineTableComparison } from '../../dtype.types';

@Component({
    selector: 'dtype-quarantine-table',
    templateUrl: 'dtype-quarantine-table.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DTypeQuarantineTableComponent implements OnInit{

    @Input() table: QuarantineTableComparison;
    @Input() compare: boolean;

    compareMode: boolean = false;
    drawTable: QuarantineTableComparison;

    constructor(
        private snackbar: MatSnackBar,
        private translocoService: TranslocoService,
    ) { }

    ngOnInit(): void {
        this.drawTable = cloneDeep(this.table);
    }

    toggleAndCopy($event: MouseEvent, item: any) {
        this.toggle($event, item);
        this.copyToClipboard();
    }

    toggle($event: MouseEvent, item: any) {
        $event.stopPropagation();
        item.show = !item.show;
    }

    toggleAllOut() {
        //this.elementTypeTooltip.show = false;
        //this.uriNameTooltip.show = false;
        //this.linkTypeTooltip.show = false;
    }

    copyToClipboard() {
        this.snackbar.open(this.translocoService.translate('copiedToClipboard'), this.translocoService.translate('accept'), { duration: 5000 });
    }

}

